var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "template-message-list" }, [
    _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "header-left" }, [
        _c("h2", [
          _vm._v(_vm._s(_vm.$t("whatsapp_business_api.templateListTitle"))),
        ]),
        _vm._v(" "),
        _vm.templates.length
          ? _c("span", { staticClass: "template-count" }, [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.$t("whatsapp_business_api.templateListShownTotal", {
                      shown: _vm.filteredTemplates.length,
                      total: _vm.templates.length,
                    })
                  ) +
                  "\n            "
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "header-actions" },
        [
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.gotoCreatePage } },
            [
              _c("a-icon", { attrs: { type: "plus" } }),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("whatsapp_business_api.templateListCreateButton")
                  ) +
                  "\n            "
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "filters-bar" },
      [
        _c("a-input-search", {
          staticStyle: { width: "250px" },
          attrs: {
            placeholder: _vm.$t(
              "whatsapp_business_api.templateListSearchPlaceholder"
            ),
            allowClear: "",
          },
          model: {
            value: _vm.searchQuery,
            callback: function ($$v) {
              _vm.searchQuery = $$v
            },
            expression: "searchQuery",
          },
        }),
        _vm._v(" "),
        _c(
          "a-select",
          {
            staticStyle: { width: "150px" },
            attrs: {
              placeholder: _vm.$t(
                "whatsapp_business_api.templateListAllCategories"
              ),
              allowClear: "",
            },
            model: {
              value: _vm.categoryFilter,
              callback: function ($$v) {
                _vm.categoryFilter = $$v
              },
              expression: "categoryFilter",
            },
          },
          [
            _c("a-select-option", { attrs: { value: "" } }, [
              _vm._v(
                _vm._s(
                  _vm.$t("whatsapp_business_api.templateListAllCategories")
                )
              ),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "MARKETING" } }, [
              _vm._v(_vm._s(_vm.$t("whatsapp_business_api.marketing"))),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "UTILITY" } }, [
              _vm._v(_vm._s(_vm.$t("whatsapp_business_api.utility"))),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "AUTHENTICATION" } }, [
              _vm._v(_vm._s(_vm.$t("whatsapp_business_api.authentication"))),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "a-select",
          {
            staticStyle: { width: "140px" },
            attrs: {
              placeholder: _vm.$t(
                "whatsapp_business_api.templateListAllStatus"
              ),
              allowClear: "",
            },
            model: {
              value: _vm.statusFilter,
              callback: function ($$v) {
                _vm.statusFilter = $$v
              },
              expression: "statusFilter",
            },
          },
          [
            _c("a-select-option", { attrs: { value: "" } }, [
              _vm._v(
                _vm._s(_vm.$t("whatsapp_business_api.templateListAllStatus"))
              ),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "APPROVED" } }, [
              _vm._v(
                _vm._s(
                  _vm.$t("whatsapp_business_api.templateListStatusApproved")
                )
              ),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "PENDING" } }, [
              _vm._v(
                _vm._s(
                  _vm.$t("whatsapp_business_api.templateListStatusPending")
                )
              ),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "REJECTED" } }, [
              _vm._v(
                _vm._s(
                  _vm.$t("whatsapp_business_api.templateListStatusRejected")
                )
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "a-button",
          {
            attrs: { loading: _vm.refreshing },
            on: { click: _vm.refreshTemplates },
          },
          [
            _c("a-icon", { attrs: { type: "sync", spin: _vm.refreshing } }),
            _vm._v(
              " " +
                _vm._s(_vm.$t("whatsapp_business_api.templateListRefresh")) +
                "\n        "
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "spacer" }),
        _vm._v(" "),
        _c("div", { staticClass: "pagination-info" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$t("whatsapp_business_api.templateListTotalTemplates", {
                  count: _vm.filteredTemplates.length,
                })
              ) +
              "\n        "
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "content-area" }, [
      _c(
        "div",
        { staticClass: "table-container" },
        [
          _c("a-table", {
            attrs: {
              columns: _vm.columns,
              "data-source": _vm.filteredTemplates,
              "row-key": function (record) {
                return record.id
              },
              pagination: _vm.tablePagination,
              "row-class-name": _vm.getRowClassName,
              customRow: _vm.customRow,
            },
            scopedSlots: _vm._u([
              {
                key: "name",
                fn: function (text, record) {
                  return [
                    _c(
                      "div",
                      { staticClass: "template-name-cell" },
                      [
                        _c("span", { staticClass: "name" }, [
                          _vm._v(_vm._s(_vm.getTemplateName(record))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a-tooltip",
                          {
                            attrs: {
                              title:
                                _vm.copiedId === _vm.getTemplateId(record)
                                  ? _vm.$t(
                                      "whatsapp_business_api.templateListCopied"
                                    )
                                  : _vm.$t(
                                      "whatsapp_business_api.templateListCopy"
                                    ),
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "template-id",
                                class: {
                                  copied:
                                    _vm.copiedId === _vm.getTemplateId(record),
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.copyTemplateId(record)
                                  },
                                },
                              },
                              [
                                _c("a-icon", { attrs: { type: "copy" } }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "whatsapp_business_api.templateListIdLabel"
                                      )
                                    ) +
                                    " " +
                                    _vm._s(_vm.getTemplateId(record)) +
                                    "\n                            "
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "language" }, [
                          _vm._v(_vm._s(_vm.getLanguageDisplay(record))),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "preview-text" }, [
                          _vm._v(_vm._s(_vm.getBodyPreview(record))),
                        ]),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "category",
                fn: function (text, record) {
                  return [
                    _c(
                      "a-tag",
                      {
                        attrs: {
                          color: _vm.getCategoryColor(
                            _vm.getTemplateCategory(record)
                          ),
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.getCategoryDisplay(record)) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "status",
                fn: function (text, record) {
                  return [
                    _c("div", { staticClass: "status-cell" }, [
                      _c("div", { staticClass: "status-content" }, [
                        _c(
                          "span",
                          {
                            staticClass: "status-badge",
                            class: _vm.getStatusClass(
                              _vm.getTemplateStatus(record)
                            ),
                          },
                          [
                            _vm.getTemplateStatus(record) === "PENDING"
                              ? _c("a-icon", {
                                  staticClass: "pending-icon",
                                  attrs: { type: "loading" },
                                })
                              : _vm.getTemplateStatus(record) === "APPROVED"
                              ? _c("a-icon", {
                                  attrs: {
                                    type: "check-circle",
                                    theme: "filled",
                                  },
                                })
                              : ["REJECTED", "FAILED"].includes(
                                  _vm.getTemplateStatus(record)
                                )
                              ? _c("a-icon", {
                                  attrs: {
                                    type: "close-circle",
                                    theme: "filled",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.getStatusText(
                                    _vm.getTemplateStatus(record)
                                  )
                                ) +
                                "\n                            "
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.getQualityScore(record)
                          ? _c(
                              "span",
                              {
                                staticClass: "quality-badge",
                                class: _vm.getQualityClass(record),
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.getQualityText(record)) +
                                    "\n                            "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      ["REJECTED", "FAILED"].includes(
                        _vm.getTemplateStatus(record)
                      ) && _vm.getRejectionInfo(record)
                        ? _c("div", { staticClass: "rejection-info" }, [
                            _c("div", { staticClass: "rejection-reason" }, [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.getRejectedReason(record))),
                              ]),
                            ]),
                            _vm._v(" "),
                            _vm.getRejectionRecommendation(record)
                              ? _c(
                                  "div",
                                  { staticClass: "rejection-recommendation" },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.getRejectionRecommendation(record)
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                },
              },
              {
                key: "lastEdited",
                fn: function (text, record) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.formatDate(record.updatedAt || record.createdAt)
                        )
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "actions",
                fn: function (text, record) {
                  return [
                    _c(
                      "a-dropdown",
                      { attrs: { trigger: ["click"] } },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "link", size: "small" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                          },
                          [_c("a-icon", { attrs: { type: "more" } })],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "a-menu",
                          { attrs: { slot: "overlay" }, slot: "overlay" },
                          [
                            _c(
                              "a-menu-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.selectTemplate(record)
                                  },
                                },
                              },
                              [
                                _c("a-icon", { attrs: { type: "eye" } }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "whatsapp_business_api.templateListPreview"
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.canEditTemplate(record)
                              ? _c(
                                  "a-menu-item",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.editTemplate(record)
                                      },
                                    },
                                  },
                                  [
                                    _c("a-icon", { attrs: { type: "edit" } }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "whatsapp_business_api.templateListEdit"
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "a-menu-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.confirmDelete(record)
                                  },
                                },
                              },
                              [
                                _c("a-icon", { attrs: { type: "delete" } }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "whatsapp_business_api.templateListDelete"
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.selectedTemplate
        ? _c("div", { staticClass: "preview-panel" }, [
            _c(
              "div",
              { staticClass: "preview-header" },
              [
                _c("h3", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("whatsapp_business_api.templateListPreviewTitle")
                    )
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    attrs: { type: "link" },
                    on: {
                      click: function ($event) {
                        _vm.selectedTemplate = null
                      },
                    },
                  },
                  [_c("a-icon", { attrs: { type: "close" } })],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "preview-content" },
              [
                _c("WhatsappMessagePreview", {
                  attrs: {
                    "template-type": _vm.getPreviewParams.templateType,
                    body: _vm.getPreviewParams.body,
                    footer: _vm.getPreviewParams.footer,
                    "header-media-type": _vm.getPreviewParams.headerType,
                    "header-text": _vm.getPreviewParams.headerText,
                    buttons: _vm.getPreviewParams.buttons,
                    headerMediaURL: _vm.getPreviewParams.headerMediaURL,
                    cards: _vm.getPreviewParams.cards,
                    "limited-time-offer": _vm.getPreviewParams.limitedTimeOffer,
                    "catalogue-sub-type": _vm.getPreviewParams.catalogueSubType,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "preview-details" }, [
              _c("div", { staticClass: "detail-item" }, [
                _c("label", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("whatsapp_business_api.templateListNameLabel")
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.getTemplateName(_vm.selectedTemplate))),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "detail-item" },
                [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("whatsapp_business_api.templateListIdLabel")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-tooltip",
                    {
                      attrs: {
                        title:
                          _vm.copiedId ===
                          _vm.getTemplateId(_vm.selectedTemplate)
                            ? _vm.$t("whatsapp_business_api.templateListCopied")
                            : _vm.$t("whatsapp_business_api.templateListCopy"),
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "template-id-detail",
                          class: {
                            copied:
                              _vm.copiedId ===
                              _vm.getTemplateId(_vm.selectedTemplate),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.copyTemplateId(_vm.selectedTemplate)
                            },
                          },
                        },
                        [
                          _c("a-icon", { attrs: { type: "copy" } }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.getTemplateId(_vm.selectedTemplate)) +
                              "\n                        "
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "detail-item" }, [
                _c("label", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("whatsapp_business_api.templateListCategoryLabel")
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.getCategoryDisplay(_vm.selectedTemplate))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "detail-item" }, [
                _c("label", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("whatsapp_business_api.templateListLanguageLabel")
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.getLanguageDisplay(_vm.selectedTemplate))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "detail-item" }, [
                _c("label", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("whatsapp_business_api.templateListStatusLabel")
                    )
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    class: _vm.getStatusClass(
                      _vm.getTemplateStatus(_vm.selectedTemplate)
                    ),
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.getStatusText(
                            _vm.getTemplateStatus(_vm.selectedTemplate)
                          )
                        ) +
                        "\n                    "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm.getRejectionInfo(_vm.selectedTemplate)
                ? _c("div", { staticClass: "detail-item" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "whatsapp_business_api.templateListReasonLabel"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "rejection-text" }, [
                      _vm._v(
                        _vm._s(_vm.getRejectedReason(_vm.selectedTemplate))
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.getRejectionRecommendation(_vm.selectedTemplate)
                ? _c("div", { staticClass: "detail-item" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "whatsapp_business_api.templateListRecommendationLabel"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "recommendation-text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.getRejectionRecommendation(_vm.selectedTemplate)
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }